export default __webpack_public_path__ + "static/media/home-icon-bottom-nav-mobile.65b147a9.webp";